import { isEmpty } from "lodash";
import React, { useEffect, useMemo } from "react";
import { RouteComponentProps } from "react-router-dom";
import Dashboard from "../../../../components/Dashboard";
import { useHotspots } from "../../../../context/hotspots";
import { useTransmitScales } from "../../../../context/transmitScales";
import { h3ToParentMemoized } from "../../../../utils/memoizedMethods";
import useMapCenter from "../../../../utils/useMapCenter";

const HexDashboardTab: React.FC<RouteComponentProps<{ h3Index: string }>> = (
  props
) => {
  const {
    hotspotsAroundCenter,
    fetchRewardSummariesByHex,
    fetchWitnessesCountsByHex
  } = useHotspots();
  const { getHexTransmitScaleInfo } = useTransmitScales();
  const centerInH3HexRes4 = useMapCenter((state) => state.centerInH3HexRes4);
  const { resolution } = getHexTransmitScaleInfo(props.match.params.h3Index);

  const hotspotsInHex = useMemo(
    () =>
      hotspotsAroundCenter.filter(
        ({ location }) =>
          h3ToParentMemoized(location, resolution) ===
          props.match.params.h3Index
      ),
    [hotspotsAroundCenter, props.match.params.h3Index, resolution]
  );

  useEffect(() => {
    if (centerInH3HexRes4) {
      fetchRewardSummariesByHex(centerInH3HexRes4);
      fetchWitnessesCountsByHex(centerInH3HexRes4); // Needed to calculate the witness reward units
    }
  }, [centerInH3HexRes4, fetchRewardSummariesByHex, fetchWitnessesCountsByHex]);

  if (isEmpty(hotspotsInHex)) {
    return (
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-50">
        There are no hotspots in this hex so far.
      </p>
    );
  }

  return <Dashboard hotspots={hotspotsInHex} />;
};

export default HexDashboardTab;
